<template>
    <v-row>
        <v-col>
            <editor
                v-model="formNote"
                api-key="ksfjgviqcct18eda69e21t7gfwzws2t4edsban1h0vbchi3m"
                :init="{
                    plugins: 'lists link image table code',
                    toolbar: ['undo redo | formatselect fontsizes forecolor backcolor | bold italic underline code | numlist bullist outdent indent | alignleft aligncenter alignright | link image'],
                    height: '500px',
                    file_picker_types: 'image',
                    images_upload_handler: uploadToS3,
                    paste_data_images: true
                }"
                @onPaste="pasteHandler"
            />
        </v-col>
    </v-row>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { EventBus } from '@/js/event-bus.js'

export default {
    components: {
        'editor': Editor,
    },

    props: {
        note : { type: String },
        integration_id : { type: Number|String },
        platform_id : { type: Number|String },
    },

    computed: {
        formNote: {
           get(){
             return this.note
           },
           set(newName){
             return newName
           }
        }
    },

    methods: {

        uploadToS3(blobInfo, success, failure, progress) {
            let formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());

            if (this.platform_id > 0) {
                formData.append('target', 'platform/'+this.platform_id)
            }
            else {
                formData.append('target', 'integration/'+this.integration_id)
            }
            console.log(this.integration_id, this.platform_id);

            this.$http
                .post('/api/integrationtypes/file-upload', formData)
                .then(res => {
                    console.log('checking result', res)
                    success(res.data.location);
                    EventBus.$emit('show-success', 'Successfully uploaded the file.');
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
        },

        pasteHandler(event, editor) {
            let paste = (event.clipboardData || window.clipboardData).getData('text');
            console.log('checking',paste, event.clipboardData);
        }
    }

}
</script>